(function(){'use strict';
if(window.__aec)return;window.__aec=1;
function init(){
  var O='[data-aec="offers"]',F='[data-aec="fulfil"]';
  function $o(){return document.querySelector(O)}
  function $f(){return document.querySelector(F)}
  var host=$o()||$f();
  if(!host)return;
  var i18n={};
  try{i18n=JSON.parse(document.querySelector('[data-aec-i18n]').textContent)}catch(e){}
  var CUT_SAME=parseFloat(host.dataset.cutoffSame)||17.5,
      CUT_NEXT=parseFloat(host.dataset.cutoffNext)||21.5,
      CUT_G=parseFloat(host.dataset.cutoffGarmin)||17,
      GARMIN=host.dataset.garminSd==='1',
      MIN_SD=parseInt(host.dataset.minSameday,10)||9900,
      FREE=parseInt(host.dataset.free,10)||9900,
      ZONE=host.dataset.zone||'AE',
      FAST=host.dataset.fast==='true',
      WEEKEND=0,
      SUB=parseInt(host.dataset.sub,10)||100,
      MULT=parseInt(host.dataset.mult,10)||10000,
      CURL=host.dataset.curLabel||host.dataset.cur||'AED',
      cartTotal=parseInt(host.dataset.cart,10)||0;
  var RTL=host.getAttribute('dir')==='rtl';
  /* currency-aware amount: GCC display conversion (MULT) + 3-decimal currencies keep 1 decimal */
  function amt(c){
    var n=(c*MULT/10000)/SUB;
    n=SUB===1000?Math.ceil(n*10)/10:Math.ceil(n);
    return CURL+' '+n;
  }
  /* ── Dubai clock ── */
  var dubaiFormatter=new Intl.DateTimeFormat('en-US',{timeZone:'Asia/Dubai',year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit',second:'2-digit',hour12:false});
  function dubaiNow(){
    var p={};
    dubaiFormatter.formatToParts(new Date()).forEach(function(x){p[x.type]=x.value});
    var h=p.hour==='24'?0:Number(p.hour);
    return new Date(Number(p.year),Number(p.month)-1,Number(p.day),h,Number(p.minute),Number(p.second));
  }
  function skipWeekend(d){var r=new Date(d);while(r.getDay()===WEEKEND)r.setDate(r.getDate()+1);return r}
  function addBizDays(d,n){var r=new Date(d),rem=n;while(rem>0){r.setDate(r.getDate()+1);if(r.getDay()!==WEEKEND)rem--}return r}

  function calendarDay(d,n){var r=new Date(d);r.setDate(r.getDate()+n);return r}
  function uaeDeliveryDates(now,fast,garmin,sameEligible,cutoffNext){
    var dec=now.getHours()+now.getMinutes()/60;
    if(garmin)return {dubai:calendarDay(now,0),from:calendarDay(now,0),to:calendarDay(now,0),all:true};
    if(sameEligible)return {dubai:calendarDay(now,0),from:calendarDay(now,1),to:calendarDay(now,1),all:false};
    var rest=fast?(dec<cutoffNext?1:2):1;
    return {dubai:calendarDay(now,1),from:calendarDay(now,rest),to:calendarDay(now,fast?rest:2),all:false};
  }
  function gccDeliveryDates(now,fast){
    var start=new Date(now);
    if(now.getHours()>=17)start.setDate(start.getDate()+1);
    start=skipWeekend(start);
    return {from:addBizDays(start,fast?2:3),to:addBizDays(start,fast?3:5)};
  }
  function fmtDate(d){return (i18n.months||[])[d.getMonth()]+' '+d.getDate()}
  function fmtHMS(ms){
    var h=Math.floor(ms/36e5),m=Math.floor(ms%36e5/6e4),s=Math.floor(ms%6e4/1e3),
        p=function(n){return n<10?'0'+n:n};
    return p(h)+':'+p(m)+':'+p(s);
  }
  function atHour(base,dec){
    var h=Math.floor(dec),m=Math.round((dec-h)*60);
    return new Date(base.getFullYear(),base.getMonth(),base.getDate(),h,m,0);
  }
  /* ── sticky bar split-4 tag ── */
  function syncSticky(price){
    if(!price||ZONE!=='AE')return;
    var oh=$o();if(oh&&oh.dataset.hideBnpl==='1'){var old=document.querySelector('.product-sticky-form .aec-sticky-mo');if(old)old.remove();return;}
    var bar=document.querySelector('.product-sticky-form');
    if(!bar)return;
    var pEl=bar.querySelector('.price');
    if(!pEl)return;
    var tag=bar.querySelector('.aec-sticky-mo');
    if(!tag){
      tag=document.createElement('span');
      tag.className='aec-sticky-mo';
      pEl.appendChild(tag);
    }
    tag.textContent=(i18n.or||'or ')+amt(Math.round(price*975/10000))+(i18n.x12||' /mo × 12');
  }
  function productScopes(){
    var h=$o()||$f(),info=h&&h.closest('product-info'),root=h&&h.closest('.shopify-section'),scopes=[];
    var form=info&&document.getElementById(info.getAttribute('form'));
    if(form)scopes.push(form);
    var sticky=root&&root.querySelector('.product-sticky-form');
    if(sticky)scopes.push(sticky);
    return scopes;
  }
  function productInputs(){
    var inputs=[];
    productScopes().forEach(function(scope){inputs=inputs.concat([].slice.call(scope.querySelectorAll('[name="id"]')));});
    return inputs;
  }
  function syncBuyButtons(st){
    productScopes().forEach(function(scope){
      scope.querySelectorAll('[name="add"],.shopify-payment-button').forEach(function(el){
        if(st==='sold_out'){
          if(!el.hasAttribute('data-aec-hidden')){el.dataset.aecHidden=el.style.display;el.style.display='none';}
        }else if(el.hasAttribute('data-aec-hidden')){el.style.display=el.dataset.aecHidden;delete el.dataset.aecHidden;}
      });
    });
  }
  /* ── free shipping progress (fulfillment card) ── */
  function syncFreeShip(price){
    var f=$f();
    if(!f)return;
    var box=f.querySelector('[data-fs]');
    if(!box)return;
    var eff=price+cartTotal,
        pct=Math.min(100,Math.round(eff/FREE*100)),
        unlocked=eff>=FREE,
        fill=box.querySelector('[data-fs-fill]'),
        msg=box.querySelector('[data-fs-msg]'),
        amtEl=box.querySelector('[data-fs-amt]');
    box.classList.toggle('is-unlocked',unlocked);
    if(fill)fill.style.width=pct+'%';
    if(unlocked){
      if(msg)msg.textContent=i18n.fs_unlocked||'';
      if(amtEl)amtEl.innerHTML='<span class="aec-hl">✓</span>';
    }else{
      if(msg)msg.textContent=(i18n.fs_add||'').replace('{amt}',amt(FREE-eff));
      if(amtEl)amtEl.innerHTML=amt(eff)+' / <span class="aec-hl">'+amt(FREE)+'</span>';
    }
  }
  /* ── delivery strips state machine (Dubai time) ── */
  var cdT=null,unT=null,prevBelow=null;
  function setFulSub(key,from,to){
    var f=$f();
    if(!f)return;
    var sub=f.querySelector('[data-dyn-sub]');
    if(!sub)return;
    var s=i18n[key]||'';
    if(from)s=s.replace('{from}',from).replace('{to}',to);
    sub.innerHTML=s;
  }
  function strips(fromCart){
    clearInterval(cdT);
    clearTimeout(unT);
    var o=$o(),f=$f(),h=o||f;
    if(!h)return;
    var st=h.dataset.status;
    syncBuyButtons(st);
    var price=parseInt((o||h).dataset.price,10)||0;
    syncFreeShip(price);
    syncSticky(price);
    if(!o)return;
    var cd=o.querySelector('[data-cd]'),
        un=o.querySelector('[data-un]'),
        nd=o.querySelector('[data-nd]'),
        eta=o.querySelector('[data-eta]'),
        etaTxt=o.querySelector('[data-eta-text]');
    function hideAll(){if(cd)cd.hidden=true;if(un)un.hidden=true;if(nd)nd.hidden=true;if(eta)eta.hidden=true}
    hideAll();
    if(st==='sold_out')return;
    var now=dubaiNow(),dec=now.getHours()+now.getMinutes()/60;
    if(ZONE==='AE'){
      var dow=now.getDay(),
          garminWin=GARMIN&&dow!==0&&dec<CUT_G,
          sameWindow=FAST&&dec<CUT_SAME,
          eff=price+cartTotal;
      if(garminWin){
        /* Garmin > AED 2500: same-day, 5PM Dubai cutoff, not on Sundays */
        if(cd){
          cd.hidden=false;
          var gcut=cd.querySelector('[data-cd-cut]');if(gcut&&i18n.cut_garmin)gcut.textContent=i18n.cut_garmin;
          var gmsg=cd.querySelector('[data-cd-msg]');if(gmsg&&i18n.cd_garmin)gmsg.innerHTML=i18n.cd_garmin;
          var gnum=cd.querySelector('[data-cd-num]');
          var gtick=function(){
            if(document.hidden)return;
            var gn=dubaiNow(),gt=atHour(gn,CUT_G),gd=gt-gn;
            if(gd<=0){strips();return}
            cd.classList.toggle('is-urgent',gd<36e5);
            if(gnum)gnum.textContent=fmtHMS(gd);
          };
          gtick();cdT=setInterval(gtick,1000);
        }
        setFulSub('sub_sd_garmin');
      }else if(sameWindow&&eff>=MIN_SD){
        /* same-day countdown */
        if(cd){
          cd.hidden=false;
          var scut=cd.querySelector('[data-cd-cut]');if(scut&&i18n.cut_same)scut.textContent=i18n.cut_same;
          var smsg=cd.querySelector('[data-cd-msg]');if(smsg&&i18n.cd_fast)smsg.innerHTML=i18n.cd_fast;
          var num=cd.querySelector('[data-cd-num]');
          var tick=function(){
            if(document.hidden)return;
            var n=dubaiNow(),target=atHour(n,CUT_SAME),diff=target-n;
            if(diff<=0){strips();return}
            cd.classList.toggle('is-urgent',diff<36e5);
            if(num)num.textContent=fmtHMS(diff);
          };
          tick();cdT=setInterval(tick,1000);
        }
        setFulSub('sub_sd');
        var wasBelow=prevBelow;prevBelow=false;
        if(fromCart===true&&wasBelow===true&&un){
          un.hidden=false;
          un.classList.add('is-done');
          unT=setTimeout(function(){un.classList.remove('is-done');un.hidden=true},2600);
        }
      }else if(sameWindow){
        /* unlock bar */
        prevBelow=true;
        if(un){
          un.hidden=false;
          un.classList.remove('is-done');
          var unAmt=un.querySelector('[data-un-amt]'),fill=un.querySelector('[data-un-fill]');
          if(unAmt)unAmt.textContent=amt(MIN_SD-eff);
          if(fill)fill.style.width=Math.min(100,Math.round(eff/MIN_SD*100))+'%';
        }
        setFulSub('sub_nd_fast');
      }else{
        /* next-day window or overnight */
        prevBelow=null;
        if(nd){
          nd.hidden=false;
          var open=dec<CUT_NEXT,
              num2=nd.querySelector('[data-nd-num]');
          nd.classList.toggle('is-closed',!open);
          var tick2=function(){
            if(document.hidden)return;
            var n=dubaiNow(),d2=n.getHours()+n.getMinutes()/60,
                target;
            if(d2<CUT_NEXT){
              nd.classList.remove('is-closed');
              target=atHour(n,CUT_NEXT);
              var diff=target-n;
              nd.classList.toggle('is-urgent',diff<36e5);
              if(num2)num2.textContent=fmtHMS(diff);
            }else{
              nd.classList.add('is-closed');
              nd.classList.remove('is-urgent');
              target=atHour(n,CUT_NEXT);
              target.setDate(target.getDate()+1);
              if(num2)num2.textContent=fmtHMS(target-n);
            }
          };
          tick2();cdT=setInterval(tick2,1000);
        }
        if(FAST)setFulSub(dec<CUT_NEXT?'sub_nd_fast':'sub_late_fast');
        else setFulSub(dec<CUT_NEXT?'sub_nd_slow':'sub_late_slow');
      }
      /* slow vendors never get same-day (except the Garmin > AED 2500 case above);
         if in same-day window hours, show next-day instead */
      if(!FAST&&!garminWin&&dec<CUT_SAME&&nd&&cd&&cd.hidden&&un&&un.hidden&&nd.hidden){
        nd.hidden=false;
      }
      var dates=uaeDeliveryDates(now,FAST,garminWin,sameWindow&&eff>=MIN_SD,CUT_NEXT),
          rest=fmtDate(dates.from)+(dates.from.getTime()===dates.to.getTime()?'':' – '+fmtDate(dates.to)),
          dateText=(i18n[dates.all?'eta_ae_all':'eta_ae']||'').replace('{dubai}',fmtDate(dates.dubai)).replace('{uae}',rest);
      if(eta&&etaTxt){eta.hidden=false;etaTxt.innerHTML=dateText;}
      var sub=f&&f.querySelector('[data-dyn-sub]');
      if(sub&&dateText)sub.innerHTML+='<span class="aec-estimate">'+dateText+'</span>';
    }else if(ZONE==='GCC'){
      var dates=gccDeliveryDates(now,FAST),from=dates.from,to=dates.to,key=FAST?'gcc_fast':'gcc_slow';
      if(eta&&etaTxt){
        eta.hidden=false;
        etaTxt.innerHTML=(i18n['eta_'+key]||'').replace('{from}',fmtDate(from)).replace('{to}',fmtDate(to));
      }
      setFulSub('sub_'+key,fmtDate(from),fmtDate(to));
    }else{
      if(eta&&etaTxt){
        eta.hidden=false;
        etaTxt.innerHTML=i18n.eta_intl||'';
      }
      setFulSub('sub_intl');
    }
  }
  /* ── cart refresh (ajax aware) ── */
  var cartRefreshTimer=null,cartRefreshPending=false,cartRefreshQueued=false;
  function scheduleCartRefresh(){clearTimeout(cartRefreshTimer);cartRefreshTimer=setTimeout(refreshCart,150);}
  function refreshCart(){
    if(cartRefreshPending){cartRefreshQueued=true;return;}
    cartRefreshPending=true;
    var cartRoot=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
    fetch(cartRoot+'cart.js').then(function(r){return r.ok?r.json():null}).then(function(c){
      if(c&&typeof c.total_price==='number'&&c.total_price!==cartTotal){cartTotal=c.total_price;strips(true);}
    }).catch(function(){}).then(function(){cartRefreshPending=false;if(cartRefreshQueued){cartRefreshQueued=false;scheduleCartRefresh();}});
  }
  var _f=window.fetch;
  window.fetch=function(input){
    var u='';
    try{u=typeof input==='string'?input:(input&&input.url)||''}catch(e){}
    var pr=_f.apply(this,arguments);
    if(/\/cart\/(add|change|update|clear)/.test(u))pr.then(function(){scheduleCartRefresh()},function(){});
    return pr;
  };
  ['cart:updated','cart:refresh','cart:change','ajaxCart:updated'].forEach(function(n){
    document.addEventListener(n,scheduleCartRefresh,{passive:true});
  });
  /* ── variant change → section re-fetch (URL is source of truth) ── */
  var timer=null,DEBOUNCE=150,requestSequence=0,requestController=null;
  function sids(){
    var s={},o=$o(),f=$f();
    if(o&&o.dataset.sid)s[o.dataset.sid]=1;
    if(f&&f.dataset.sid)s[f.dataset.sid]=1;
    return Object.keys(s);
  }
  function fetchSection(vid,sid,signal){
    var u=new URL(location.href);u.searchParams.set('variant',vid);u.searchParams.set('section_id',sid);
    return fetch(u.pathname+u.search,{signal:signal,headers:{'X-Requested-With':'XMLHttpRequest'}})
      .then(function(r){if(!r.ok)throw new Error(r.status);return r.text()});
  }
  function gallerySig(g){
    var s='',els=g.querySelectorAll('[data-media-id]');
    for(var i=0;i<els.length;i++)s+=els[i].getAttribute('data-media-id')+'|'+(els[i].className||'')+';';
    return s;
  }
  function reorderPicker(){
    var o=$o();
    if(!o)return;
    var rows=o.querySelectorAll('.aec-vp-vals');
    for(var ri=0;ri<rows.length;ri++){
      var row=rows[ri],
          btns=[].slice.call(row.querySelectorAll('.aec-vp-v'));
      if(btns.length<2)continue;
      var ranked=btns.map(function(b,i){
        var r=1;
        if(b.classList.contains('is-disabled'))r=3;
        else if(b.classList.contains('is-oos'))r=2;
        return {b:b,r:r,i:i};
      });
      ranked.sort(function(a,c){return a.r-c.r||a.i-c.i});
      var changed=false;
      for(var k=0;k<ranked.length;k++){if(ranked[k].b!==btns[k]){changed=true;break}}
      if(changed)for(var m=0;m<ranked.length;m++)row.appendChild(ranked[m].b);
    }
  }
  function swap(html){
    var doc=new DOMParser().parseFromString(html,'text/html');
    [O,F].forEach(function(sel){
      var nw=doc.querySelector(sel),old=document.querySelector(sel);
      if(nw&&old)old.replaceWith(nw);
    });
    var h=$o()||$f(),root=h&&h.closest('.shopify-section');
    var fg=doc.querySelector('media-gallery'),lg=root&&root.querySelector('media-gallery');
    if(fg&&lg&&gallerySig(fg)!==gallerySig(lg))lg.replaceWith(fg);
    productScopes().forEach(function(scope){
      var fresh=scope.id&&doc.getElementById(scope.id);
      if(!fresh)return;
      scope.querySelectorAll('[name="id"]').forEach(function(input){var value=fresh.querySelector('[name="id"]');if(value)input.value=value.value;});
      var button=scope.querySelector('[name="add"]'),freshButton=fresh.querySelector('[name="add"]');
      if(button&&freshButton){
        button.disabled=freshButton.disabled;
        ['aria-disabled','aria-label'].forEach(function(attr){if(freshButton.hasAttribute(attr))button.setAttribute(attr,freshButton.getAttribute(attr));else button.removeAttribute(attr);});
        var label=button.querySelector('.btn-text'),freshLabel=freshButton.querySelector('.btn-text');
        if(label&&freshLabel)label.innerHTML=freshLabel.innerHTML;
      }
    });
    reorderPicker();
  }
  function dim(on){
    [$o(),$f()].forEach(function(el){
      if(el)el.style.opacity=on?'0.45':'';
    });
  }
  function update(){
    var w=$o()||$f();
    if(!w)return;
    var vid=new URLSearchParams(location.search).get('variant');
    if(!vid||w.dataset.vid===vid)return;
    var ids=sids();
    if(!ids.length)return;
    dim(true);
    var sequence=requestSequence;
    requestController=new AbortController();
    var signal=requestController.signal;
    var done=0;
    ids.forEach(function(sid){
      fetchSection(vid,sid,signal).then(function(t){
        if(sequence!==requestSequence||new URLSearchParams(location.search).get('variant')!==vid)return;
        swap(t);
        done++;
        if(done===ids.length){
          strips();
          dim(false);
        }
      }).catch(function(err){
        if(err.name==='AbortError'||sequence!==requestSequence)return;
        if(window.console)console.error('[AEC]',err);
        dim(false);
      });
    });
  }
  function refresh(){
    requestSequence++;
    if(requestController){requestController.abort();requestController=null;}
    dim(false);
    clearTimeout(timer);
    timer=setTimeout(update,DEBOUNCE);
  }
  document.addEventListener('variant:change',function(e){
    if(e.detail&&e.detail.variant&&e.detail.variant.id){
      var u=new URL(location);
      u.searchParams.set('variant',e.detail.variant.id);
      history.replaceState({},'',u);
      refresh();
    }
  },{passive:true});
  document.addEventListener('variantChange',function(){refresh()},{passive:true});
  var _p=history.pushState,_r=history.replaceState;
  history.pushState=function(){_p.apply(this,arguments);refresh()};
  history.replaceState=function(){_r.apply(this,arguments);refresh()};
  window.addEventListener('popstate',refresh,{passive:true});
  document.addEventListener('shopify:section:load',refresh,{passive:true});
  /* ── widget variant picker (native radios first, form+URL fallback) ── */
  document.addEventListener('click',function(e){
    var b=e.target&&e.target.closest&&e.target.closest('.aec-vp-v');
    if(!b||b.classList.contains('is-disabled')||b.classList.contains('is-on'))return;
    var optEl=b.closest('.aec-vp-opt'),
        optName=(optEl&&optEl.dataset.optName)||'',
        val=b.dataset.val||'',
        vid=b.dataset.vid||'';
    var wrap=b.closest('.aec-vp-vals');
    if(wrap){
      var sib=wrap.querySelectorAll('.aec-vp-v');
      for(var i=0;i<sib.length;i++)sib[i].classList.remove('is-on');
      b.classList.add('is-on');
    }
    /* sparse matrix jump: this value needs the OTHER option(s) to change too, so a
       single native-radio click can't express it — jump straight to the resolved
       variant id (URL + form id + section refetch keep everything in sync). */
    if(b.dataset.jump&&vid){
      var jels=productInputs();
      for(var jk=0;jk<jels.length;jk++){jels[jk].value=vid;jels[jk].dispatchEvent(new Event('change',{bubbles:true}));}
      var ju=new URL(location);ju.searchParams.set('variant',vid);history.replaceState({},'',ju);
      refresh();
      return;
    }
    var radios=document.querySelectorAll('variant-picker input[type="radio"], variant-radios input[type="radio"], .product-form__input input[type="radio"]'),hit=null;
    for(var j=0;j<radios.length;j++){
      var r=radios[j];
      if(r.value===val&&optName&&r.name.indexOf(optName)===0){hit=r;break}
    }
    if(hit){
      if(!hit.checked)hit.click();
      return;
    }
    if(!vid)return;
    var els=productInputs();
    for(var k=0;k<els.length;k++){
      els[k].value=vid;
      els[k].dispatchEvent(new Event('change',{bubbles:true}));
    }
    var u=new URL(location);
    u.searchParams.set('variant',vid);
    history.replaceState({},'',u);
    refresh();
  },{passive:true});
  /* ── reviews chip → scroll to reviews list ── */
  document.addEventListener('click',function(e){
    var b=e.target&&e.target.closest&&e.target.closest('[data-rev]');
    if(!b)return;
    var els=document.querySelectorAll('#judgeme_product_reviews,.jdgm-rev-widg,#looxReviews,[id*="klaviyo_reviews"],[id*="review"]');
    if(els.length)els[els.length-1].scrollIntoView({behavior:'smooth',block:'start'});
  },{passive:true});
  /* ── Intercom above sticky bar on mobile ── */
  try{
    if(matchMedia('(max-width:768px)').matches){
      window.intercomSettings=window.intercomSettings||{};
      window.intercomSettings.vertical_padding=100;
      if(typeof window.Intercom==='function')window.Intercom('update',{vertical_padding:100});
    }
  }catch(e){}
  document.addEventListener('visibilitychange',function(){if(!document.hidden)strips();});
  strips();
  setInterval(function(){if(!document.hidden)strips();},60000);
  reorderPicker();
}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init)}
else{setTimeout(init,1)}
})();
